import api from './api';

export const fetchEmployees = () => api.get('/employees');
export const archiveEmployee = (employeeId) => api.post(`/employees/${employeeId}/archive`);
export const unarchiveEmployee = (employeeId) => api.post(`/employees/${employeeId}/unarchive`);
export const listInactiveEmployees = () => api.get('/employees/inactifs');
export const updateUsername = (employeeId, username) => api.put(`/employees/${employeeId}/username`, { username });

export default { fetchEmployees, archiveEmployee, unarchiveEmployee, listInactiveEmployees, updateUsername };
